import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp } from '@ifeng-fe/callapp';

const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

class FiXbottom extends React.PureComponent {
    static propTypes = {
        pageInfo: PropTypes.object,
    };

    handleClick = params => {
        // 统计
        this.pageCount(params);

        const { type, id, url, userId } = params;
        const doc_type = type;
        const aid = id;
        const kind = 'inter_fxy03';
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            userId,
            kind,
        });
    };

    pageCount = params => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'carefor',
                other: {
                    ref: encodeURIComponent(decodeURIComponent(location.href)),
                    kind: this.getKind(params),
                    // kind: fromPage === 'home' ? 'main_tag' : 'selfpage',
                },
            },
        ]);
    };

    getKind = params => {
        const { fromPage, fromType } = params;
        let kind = 'selfpage';

        if (fromPage === 'home' && fromType === 'source') {
            kind = 'main_tag';
        } else if (fromPage === 'home') {
            kind = 'vampire';
        }

        return kind;
    };

    render() {
        const { pageInfo = {} } = this.props;

        return (
            <div className={styles.fix_bottom} onClick={() => this.handleClick(pageInfo)}>
                <a href="javascript:;" className={styles.fix_follow} type="guanzhu">
                    + 关注
                </a>
            </div>
        );
    }
}

export default FiXbottom;
